import { useState, useCallback } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';

// Hook simple pour rechercher une plainte par référence (GET unique, pas de temps réel)
export const usePlainteSearch = () => {
  const [plainte, setPlainte] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const searchPlainte = useCallback(async (reference) => {
    if (!reference) {
      setError('Veuillez entrer une référence');
      return;
    }

    setLoading(true);
    setError(null);
    setPlainte(null);

    try {
      console.log('Recherche de la Réclamation avec référence:', reference);
      
      // Récupérer toutes les plaintes
      const snapshot = await getDocs(collection(db, 'plaintes'));
      
      console.log('Nombre de Réclamation trouvées:', snapshot.size);
      
      const plaintes = snapshot.docs.map(doc => {
        const data = doc.data();
        return {
          id: doc.id,
          ...data,
          date: data.date.toDate ? data.date.toDate() : new Date(data.date)
        };
      });

      // Log toutes les références pour déboguer
      console.log('Références disponibles:', plaintes.map(p => p.reference));

      // Chercher la plainte avec la référence (insensible à la casse)
      const searchRef = reference.toUpperCase().trim();
      const found = plaintes.find(p => 
        p.reference && p.reference.toUpperCase() === searchRef
      );

      if (found) {
        console.log('Réclamation trouvée:', found);
        setPlainte(found);
        setError(null);
      } else {
        console.log('Aucune Réclamation trouvée avec la référence:', searchRef);
        setError('Aucune Réclamation trouvée avec cette référence');
        setPlainte(null);
      }
    } catch (err) {
      console.error('Erreur recherche Réclamation:', err);
      setError(err.message || 'Erreur lors de la recherche');
      setPlainte(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setPlainte(null);
    setError(null);
    setLoading(false);
  }, []);

  return { plainte, loading, error, searchPlainte, reset };
};

